import { Controller } from '@hotwired/stimulus'
import Helpers from '../../helpers'
import { submitInvestRobotForm, submitInvestRobotCancelForm } from '../mixins/invest_robot_form.js'

export default class NewInvestmentFlowPlanInvestmentController extends Controller {
  static targets = [
    'createOrEditModal',
    'createOrEditContent',
    'confirmationContent',
    'successContent',
    'notEnoughMoneyContent',
    'deleteContent',
    'amountInput',
    'amountDisplayInput',
    'createSubmitButton',
    'confirmationHiddenAmountInput',
    'confirmationSubmitButton',
    'invalidAmountMessage',
    'successMessage',
  ];

  static values = {
    errorMessage: String,
  }

  openCreateOrEditModal() {
    bootstrap.Modal.getOrCreateInstance(this.createOrEditModalTarget).show();
  }

  resetCreateOrEditForm() {
    this.amountInputTarget.value = null;
    this.amountInputTarget.dispatchEvent(new Event('input'));
    this.displayStep('createOrEdit');
  }

  focusAmountInput() {
    this.amountDisplayInputTarget.focus();
  }

  checkAmountAndEnableSubmitButton() {
    const amount = parseFloat(this.amountInputTarget.value);
    const maxValue = parseFloat(this.amountInputTarget.dataset.maxValue);
    const isValid = !isNaN(amount) && amount > 0 && amount <= maxValue;

    this.invalidAmountMessageTarget.classList.toggle('d-block', !isValid && !isNaN(amount));
    this.invalidAmountMessageTarget.classList.toggle('d-none', isValid || isNaN(amount));
    this.createSubmitButtonTarget.disabled = !isValid;
  }

  displayConfirmationForm(event) {
    event.preventDefault();

    const amount = parseFloat(this.amountInputTarget.value);
    const prefixLabel = this.confirmationSubmitButtonTarget.dataset.prefixLabel;
    const label = `${prefixLabel} ${Helpers.integerCurrencyFormater.format(amount)}`;

    this.confirmationHiddenAmountInputTarget.value = amount;
    this.confirmationSubmitButtonTarget.value = label;
    this.confirmationSubmitButtonTarget.textContent = label;

    this.displayStep('confirmation');
  }

  displayCancelForm(event) {
    event.preventDefault();
    this.displayStep('delete');
  }

  submitCreateForm(event) {
    return this.submitInvestmentForm(event, { handleAlreadyExists: true });
  }

  submitUpdateForm(event) {
    return this.submitInvestmentForm(event);
  }

  async submitInvestmentForm(event, { handleAlreadyExists = false } = {}) {
    event.preventDefault();

    await submitInvestRobotForm(event.target, {
      onSuccess: (result) => {
        this.successMessageTarget.innerHTML = result.success_message_html;
        this.displayStep('success');
      },
      onAlreadyExists: handleAlreadyExists ? () => this.reloadPage() : null,
      onInsufficientFunds: () => this.displayStep('notEnoughMoney'),
      onError: (result) => toastr.error(result?.errors || this.errorMessageValue),
    });
  }

  async submitCancelForm(event) {
    event.preventDefault();

    await submitInvestRobotCancelForm(event.target, {
      onSuccess: () => this.reloadPage(),
      onError: () => toastr.error(this.errorMessageValue),
    });
  }

  displayStep(step) {
    const steps = {
      createOrEdit: this.createOrEditContentTarget,
      confirmation: this.confirmationContentTarget,
      success: this.successContentTarget,
      notEnoughMoney: this.notEnoughMoneyContentTarget,
      delete: this.deleteContentTarget,
    };

    Object.entries(steps).forEach(([key, content]) => {
      content.classList.toggle('d-none', key !== step);
    });
  }

  reloadPage() {
    window.location.reload();
  }
}
